import { render, staticRenderFns } from "./icon_list.vue?vue&type=template&id=03198476&"
import script from "./icon_list.vue?vue&type=script&lang=js&"
export * from "./icon_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports